import Index from '@/views/common/Index'
import Main from '@/views/common/Main'

export default [
{
  path: '/index',
  name: 'index',
  redirect: 'home',
  meta: {
    auth: true
  },
  component: Index,
  children: [
    {
      path: '/system/user',
      meta: {
        auth: true,
        title: "用户管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'user',
        component: resolve => require(['@/views/system/UserList'], resolve)
      },
      {
        path: '/system/user/insert',
        meta: {
          auth: true,
          title: "用户新增"
        },
        name: 'userAdd',
        component: resolve => require(['@/views/system/UserEdit'], resolve)
      },
      {
        path: '/system/user/update',
        meta: {
          auth: true,
          title: "用户编辑"
        },
        name: 'userEdit',
        component: resolve => require(['@/views/system/UserEdit'], resolve)
      }]
    },
    //----------系统管理-角色管理----------
    {
      path: '/system/role',
      meta: {
        auth: true,
        title: "角色管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'role',
        component: resolve => require(['@/views/system/RoleList'], resolve)
      },]
    },
    //----------系统管理-资源管理----------
    {
      path: '/system/resource',
      meta: {
        auth: true,
        title: "资源管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'resource',
        component: resolve => require(['@/views/system/ResourceList'], resolve)
      },]
    },
    //----------系统管理-权限管理----------
    {
      path: '/system/permission',
      meta: {
        auth: true,
        title: "权限管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'permission',
        component: resolve => require(['@/views/system/PermissionList'], resolve)
      },]
    },
    //----------系统管理-代码集管理----------
    {
      path: '/system/codelist',
      meta: {
        auth: true,
        title: "代码集管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'codelist',
        meta: {
          keepAlive: true
        },
        component: resolve => require(['@/views/system/CodelistList'], resolve)
      },
      {
        path: '/system/codelist/detail',
        name: 'codelist/detail',
        meta: {
          auth: true,
          title: "代码集详情",
          keepAlive: false
        },
        component: resolve => require(['@/views/system/CodelistDetail'], resolve)
      },
      ]
    },
    //----------系统管理-组织机构管理----------

    {
      path: '/system/organization',
      meta: {
        auth: true,
        title: "组织机构管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'organization',
        component: resolve => require(['@/views/system/OrganizationList'], resolve)
      }]
    },

    //----------系统管理-邮箱管理----------
    {
      path: '/system/mail',
      meta: {
        auth: true,
        title: "邮箱管理",
        isRedirect: true
      },
      component: Main,
      children: [{
        path: '/',
        name: 'mail',
        component: resolve => require(['@/views/system/MailList'], resolve)
      },]
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/system.js